<template >
  <div class="animated fadeIn" >
    <b-row>
      <b-col md="12">
        <b-card>
          <b-row>
            <div class="kpiList">
              <div class="form-group row">
                <label for="Branch" class="col-sm-2 col-form-label font-weight-bold">Branch</label>
                <div class="col-sm-6">
                    <select name="tahun" id="branch" v-model="branch" class="custom-select custom-select-sm">
                      <option v-for="bran in branchs" :value="bran.id">{{bran.name}}</option>
                    </select>
                    <span class="text-danger" v-if="!branch && isSubmit ">
                      Please Select Branch
                    </span>
                </div>
              </div>
              <div class="from-group row">
                <label for="" class="col-sm-2 col-form-label font-weight-bold">Name</label>
                <div class="col-sm-9">
                  <Select2 v-model="myValues" :settings="setting" :options="list" />
                  <span class="text-danger" v-if="myValues.length == 0 && isSubmit ">
                      Please Select User
                    </span>
                </div>

                <div class="col-sm-1">
                  <button class="btn " @click="alluser" v-bind:class="{'btn-info': !check,'btn-second': check}">{{checkName}}</button>
                </div>
              </div>
              <div class="form-group row">
                <div class="offset-2 col-sm-10">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="customRadioInline1" name="customRadioInline1" v-model="radio"
                           class="custom-control-input" value="1" checked>
                    <label class="custom-control-label" for="customRadioInline1">Periodik</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="customRadioInline2" name="customRadioInline1" v-model="radio"
                           class="custom-control-input" value="2">
                    <label class="custom-control-label" for="customRadioInline2">Custom</label>
                  </div>
                </div>
              </div>
              <template v-if="radio == 1">
                <div class="form-group row">
                  <label for="" class="col-sm-2 col-form-label font-weight-bold">Year</label>
                  <div class="col-sm-6">
                    <select name="tahun" id="tahun" v-model="years" class="custom-select custom-select-md">
                      <option v-for="years in year" :value="years">{{years}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="Month" class="col-sm-2 col-form-label font-weight-bold">Month</label>
                  <div class="col-sm-6">
                    <select name="bulan" id="bulan" v-model="bulan" class="custom-select custom-select-md">
                      <option v-for="months in month" :value="months">{{months}}</option>
                    </select>

                  </div>
                </div>
              </template>
              <template v-else>
                <div class="form-group row">
                  <label for="From" class="col-sm-2 col-form-label font-weight-bold">From</label>
                  <div class="col-sm-8">
                    <date-picker v-model="start" lang="en" format="DD/MM/YYYY" :not-before="not_before_date"></date-picker>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="Until" class="col-sm-2 col-form-label font-weight-bold">Until</label>
                  <div class="col-sm-8">
                    <date-picker v-model="end" lang="en" format="DD/MM/YYYY" :not-before="not_before_date"></date-picker>
                  </div>
                </div>
              </template>
              <div class="form-group row">
                <div class="col-sm-6 offset-2">
                  <button @click="submit" class="btn btn-primary">Submit</button>
                </div>
              </div>
            </div>
          </b-row>
          <!-- Untuk Tanggal -->
          <b-row>
            <div class="table-responsive horizontal-scroll" v-if="data_KPI.length > 0" id="parent">
              <arrow :body="'mybody'" :leftStyle="'400px'"/>

              <table class="table table-bordered treand" width="100%" id="table-Month">
                <thead ref="head" id="myhead">
                  <tr>
                    <th class="defaultHead"></th>
                    <th v-for="row in descDateArray" :colspan="row.colspan" style="text-align: center"> {{row.month}}</th>
                    <th rowspan="2">Total</th>
                  </tr>
                  <tr class="header" align="center">
                    <th id="periode" >Periode</th>
                    <th v-for="day in dateArray"  class="minw">{{day.date | minTwoDigit}}</th>
                  </tr>
                </thead>
                <tbody class="bodySame" id="mybody" v-on:scroll="fixscroll()" >
                <template v-for="item in data_KPI">
                  <tr>
                    <td class="bg-info tag" ref="column">{{item.outline}}</td>
                    <td :colspan="dateArray.length + 1" class="bg-info"><span class="textper">{{item.outline}}</span></td>
                  </tr>
                  <template v-for="(item_key,index) in item.permformance_key">
                    <tr>
                      <td v-b-toggle="'row' + index"
                          @click="makedata(item_key.value, false)">{{item_key.name}}</td>
                      <td v-for="(day, indeks) in dateArray" align="center" class="minw">
                        <template v-if="item_key.value.length != 0">
                          <template v-if="index == 11">
                            <span @click="goToModal(item_key.value, indeks, index)"
                                  style="cursor: pointer">{{item_key.value | nextValue(indeks, false)}}</span>
                          </template>
                          <template v-else-if="index == 15">
                            <span @click="goToModal(item_key.value, indeks, index)"
                                  class="namePointer"
                                  style="cursor: pointer">{{item_key.value | nextValue(indeks, false)}}</span>
                          </template>

                          <template v-else-if="index == 27">
                              <span @click="goToModal(item_key.value, indeks, index)"
                                    class="namePointer"
                                    style="cursor: pointer">
                                {{item_key.value | nextValue(indeks, false)}}
                              </span>
                          </template>
                          <template v-else>
                            <a :href="item_key.value | valueGetHref(indeks)">{{item_key.value | nextValue(indeks, false)}}</a>
                          </template>

                        </template>
                      </td>
                      <td>
                        <a :href="goToMonth(index, radio)">
                          {{item_key | total(index, false)}}
                        </a>

                      </td>
                    </tr>
                   <!-- <tr v-if="item_key.visible">
                      <td :colspan="totalday + 2">
                        <b-collapse :id="'row' + index" accordion="my-accordion">
                          <chart :chart-data="datacollection"
                                 class="chart-container"
                                 style="position: relative; height:40vh; width:100%"></chart>
                        </b-collapse>
                      </td>
                    </tr>-->
                  </template>
                </template>
                </tbody>

              </table>
            </div>

            <!-- Untuk Bulan -->
            <div class="table-responsive horizontal-scroll" v-if="data_KPI_month.length > 0 && radio == 1" id="parent1">
              <table class="table table-bordered treand" width="100%" id="table-Months">
                <thead id="myhead1">
                  <tr align="center">
                    <th class="bg-info tag oke" id="periodeMonth">Month</th>
                    <th v-for="month in monthArrayName" class="minw">{{month.date}}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody class="bodySame" id="mybody1" v-on:scroll="fixscroll1()">
                <template v-for="item in data_KPI_month">
                  <tr>
                    <td class="bg-info tag">{{item.outline}}</td>
                    <td :colspan="monthArray.length + 1" class="bg-info"><span class="textper">{{item.outline}}</span></td>
                  </tr>
                  <template v-for="(item_key,index) in item.permformance_key">
                    <tr>
                      <td v-b-toggle="'row' + index"
                          @click="makedata(item_key.value, true)"
                          ref="columnMonth">{{item_key.name}}</td>
                      <td v-for="(month, indeks) in monthArray" align="center" class="minw">
                        <template v-if="item_key.value.length != 0">
                          <template v-if="index == 11">
                            <span @click="goToModal(item_key.value, indeks, index)"
                                  style="cursor: pointer">{{item_key.value | nextValue(indeks, true)}}</span>
                          </template>
                          <template v-else-if="index == 15">
                            <span @click="goToModal(item_key.value, indeks, index)"
                                  class="namePointer"
                                  style="cursor: pointer">{{item_key.value | nextValue(indeks, true)}}</span>
                          </template>
                          <template v-else-if="index == 27">
                              <span @click="goToModal(item_key.value, indeks, index)"
                                    class="namePointer"
                                    style="cursor: pointer">
                                {{item_key.value | nextValue(indeks, true)}}
                              </span>
                          </template>
                          <template v-else>
                           <a :href="item_key.value | valueGetHref(indeks)">{{item_key.value | nextValue(indeks, true)}}</a>
                          </template>

                        </template>
                      </td>
                      <td> {{item_key | total(index, true)}} </td>
                    </tr>
                   <!-- <tr v-if="item_key.visible">
                      <td :colspan="totalday + 2">
                        <b-collapse :id="'row' + index" accordion="my-accordion">
                          <chart :chart-data="datacollection"
                                 class="chart-container"
                                 style="position: relative; height:40vh; width:100%"></chart>
                        </b-collapse>
                      </td>
                    </tr>-->
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </b-row>
          <br>
          <br>
          <b-row>
            <div class="table-responsive">

            </div>
          </b-row>

          <!--<div class="small" v-show="chartBoolean">
            <chart :chart-data="datacollection"></chart>
          </div>-->

        </b-card>
      </b-col>
    </b-row>

    <!--index 15-->
    <b-modal title="Persentase call answer by helpdesk" class="modal-info" size="sm" v-model="persentase"
             @ok="persentase = false">
      <div align="center" style="font-size: 20px;">
        CAll : <a >{{call}}</a>
        <br>
        ANSWER : <a :href="hrefCall">{{answer}}</a>
      </div>
    </b-modal>

    <!--index 11-->
    <b-modal title="Persentase tiket problem solved by remote" class="modal-info" size="sm" v-model="remote"
             @ok="remote = false">
      <div align="center" style="font-size: 20px;">
        <h3>Ticket</h3>
        <table>
          <tr>
            <td>Create Today</td>
            <td>:</td>
            <td>{{today}}</td>
          </tr>
          <tr>
            <td>Create Previous</td>
            <td>:</td>
            <td>{{prev}}</td>
          </tr>
          <tr>
            <td>Create Total</td>
            <td>:</td>
            <td>
              <a :href="hrefCreate">{{total}}</a>
            </td>
          </tr>
          <tr>
            <td>Solved Total</td>
            <td>:</td>
            <td>
              <a :href="hrefSolved">{{solved}}</a></td>
          </tr>
        </table>
      </div>
    </b-modal>
    <!--index 27-->
    <b-modal title="Persentase tiket problem solved by remote dengan open problem kunjungan" class="modal-info" size="sm" v-model="open_problem"
             @ok="open_problem = false">
      <div align="center" style="font-size: 20px;">
        <table>
          <tr>
            <td>Solved</td>
            <td>:</td>
            <td>
              <a :href="hrefSolved">
                {{solved}}
              </a></td>
          </tr>
          <tr>
            <td>Visit</td>
            <td>:</td>
            <td>
              <a :href="hrefVisit">{{visit}}</a></td>
          </tr>
          <tr>
            <td>Case Total</td>
            <td>:</td>
            <td>
              {{case_total}}
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>

</template>


<script>
  import {getService} from '@/services'
  import moment from 'moment'
  /*import Chart from '@/component/Chart'*/
  import {random} from '@/shared/utils'
  import data from '@/component/data'
  import DatePicker from 'vue2-datepicker'
  import HrefList from '@/component/href/HrefList'
  import Arrow from '../../component/Arrow'

  export default {
    components: {
      // Chart,
      DatePicker,
      'href-list': HrefList,
      Arrow
    },
    data() {
      return {
        year: data.year,
        years: moment().format('YYYY'),
        bulan: moment().format('MMMM'),
        name: 'Data',
        branch: '020',
        datacollection: null,
        month: data.month,
        label: [],
        branchs: [],
        labelMonth: [],
        date: Date.now(),
        totalday: 0,
        myValue: '',
        data_KPI: [],
        data_KPI_month: [],
        descDateArray: [],
        descYear: [],
        dateArray: [],
        monthArray: [],
        monthArrayName: [],
        start: '',
        end: '',
        employee: [],
        myValues: '',
        myOptions: '',
        list: [],
        radio: 1,
        x : [11, 10, 10, 5, 10, 15, 20, 10, 7, 11],
        urlParam: '',
        persentase: false,
        remote: false,
        open_problem: false,
        hrefCreate: '',
        hrefSolved: '',
        hrefVisit: '',
        hrefCall: '',
        setting: {
          'multiple': true,
          'width': '100%'
        },
        call: 0,
        answer: 0,
        today: 0,
        prev: 0,
        total: 0,
        solved: 0,
        visit: 0,
        case_total: 0,
        isSubmit: false,
        checkName: 'All',
        check: false,
        not_before_date: '04/01/2019'
      }
    },
    created: function () {
      this.start = moment(Date.now()).subtract(1, 'months').format('YYYY-MM-26')
      this.end = moment(Date.now()).format('YYYY-MM-25')
      this.getEmployee()
      this.getBranch()
      let months
      this.totalday = moment(this.date).daysInMonth();
      months = this.month
      for (let j = 1; j <= 12; j++) {
        if (months > 11) {
          months = 1
        } else {
          months++
        }
        const month = {
          'month': months
        }
        this.monthArray.push(month)
      }
    },
    watch: {
      bulan: function (val) {
        let date = this.years + '-' + val
        this.start = moment(date, 'YYYY-MMMM').subtract(1, 'months').format('YYYY-MM-26')
        this.end = moment(date, 'YYYY-MMMM').format('YYYY-MM-25')
      },
      years: function (val) {
        let date = val + '-' + this.bulan
        this.start = moment(date, 'YYYY-MMMM').subtract(1, 'months').format('YYYY-MM-26')
        this.end = moment(date, 'YYYY-MMMM').format('YYYY-MM-25')
      },
      data_KPI_month() {
        setTimeout(()=> {
           var table = document.getElementById('mybody1')
        var max = table.scrollWidth
        var layout = table.offsetWidth
        table.scrollLeft = max - layout
        }, 2000)
      }
    },
    mounted: function () {
      if (this.$route.query.mode) {
        document.addEventListener('scroll', this.handlescroll)
        this.myValues = this.$route.query.user.split(',');
        this.radio = this.$route.query.mode == 1 ? 2 : 1;
        this.start = this.$route.query.start;
        this.end = this.$route.query.end;
        if (this.radio == 1) {
          this.bulan = moment(this.$route.query.start, 'YYYY-MM').format('MMMM')
          this.years = moment(this.$route.query.start, 'YYYY-MM').format('YYYY')
        }
        this.getData(this.start, this.end, this.$route.query.user, this.$route.query.mode == 1 ? false : true)
      }
    },
    updated: function () {
      if (this.myValues.length == this.list.length ) {
        this.check = true
        this.checkName = 'Uncheck'
      } else if (this.myValues.length == 0) {
        this.check = false
        this.checkName = 'All'
      }
    },
    beforeRouteUpdate(to, from, next) {
      if (to.query.mode == 1) {
        this.getData(to.query.start, to.query.end, to.query.user, false)
      } else if (to.query.mode == 0) {
        this.getData(to.query.start, to.query.end, to.query.user, true)
      }
      next()
    },
    methods: {
      fixscroll() {
        const thead = document.getElementById("myhead");
        const tbodyScroll = document.getElementById("mybody").scrollLeft;
        thead.scrollLeft = tbodyScroll;
        //document.getElementById("frozen").scrollLeft = 0;
      },
      fixscroll1() {
        const thead = document.getElementById("myhead1");
        const tbodyScroll = document.getElementById("mybody1").scrollLeft;
        thead.scrollLeft = tbodyScroll;
        //document.getElementById("frozen").scrollLeft = 0;
      },
      myChangeEvent(val) {
        // console.log(val);
      },
      mySelectEvent({id, text}) {
        // console.log({id, text})
      },
      daysRemaining(start, end) {
        var eventdate = moment(end);
        var todaysdate = moment(start);
        return eventdate.diff(todaysdate, 'days');
      },
      getEmployee: function () {
        getService.list_employee()
          .then(
            employee => {
              var ary = []
              this.employee = employee
              for (let i = 0; i < employee.length; i++) {
                const obj = {
                  id: employee[i].EmpId,
                  text: employee[i].EmpFName + ' ' + employee[i].EmpLName
                }
                ary.push(obj)
              }
              this.list = ary
            }
          )
      },
      getData: function (start, end, user, month) {
        var user = user
        if (month == true) {
          start = moment(start, 'YYYY-MM').startOf('month').format('YYYY-MM-DD')
          end = moment(end, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')
          const data = {
            month: true
          }
          this.getDataKPI(user, data, true)
        }
        const date = {
          start: start,
          end: end,
          month: false
        }
        this.getDataKPI(user, date, false)
      },
      getDataKPI: function (user, date, month) {
        this.$store.commit('noLoad', true)
        getService.list_helpdesk(user, date)
          .then(
            data => {
              this.$store.commit('noLoad', false)
              let j
              if (month == true) {
                this.data_KPI_month = []
                this.labelMonth = []
                this.monthArray = []
                this.data_KPI_month = data.details
                var max_month = 12
                var month_now = parseInt(moment().format('M')) + 1
                let start = data.start.substring(0,4)
                for (let i = 1; i <= 12; i++) {
                  if (month_now > max_month) {
                    month_now = 1
                    start ++;
                  }

                  const m = {
                    'date': month_now 
                  }
                  const n = {
                    date: (month_now | this.minTwoDigit) + '-' + start
                  }
                  this.monthArray.push(m)
                  this.monthArrayName.push(n)
                  this.labelMonth.push(i)
                  month_now++
                }
              } else {
                var start, end, monthNow, t = 0
                this.dateArray = []
                this.descDateArray = []
                this.label = []
                this.data_KPI = []
                this.data_KPI = data.details
                start = moment(data.start, 'YYYY-MM-DD')
                end = moment(data.end, 'YYYY-MM-DD')
                monthNow = moment(data.start,'YYYY-MM-DD').format('MMMM')
                let diff, starts, max_date
                diff = end.diff(start, 'days') + 1
                this.totalday = diff
                starts = moment(data.start, 'YYYY-MM-DD').format('D')
                max_date = moment(data.start, 'YYYY-MM-DD').daysInMonth()
                for (let i = 1; i <= this.totalday; i++) {
                  if (starts > max_date) {
                    starts = 1
                    const m_d = {
                      'colspan' : t,
                      'month': monthNow
                    }
                    this.descDateArray.push(m_d)
                    max_date = moment(data.start, 'YYYY-MM-DD').add(1, 'months').daysInMonth()
                    monthNow = moment(monthNow,'MMMM').add(1, 'months').format('MMMM')
                    t = 0
                  }
                  const day = {
                    'date': starts
                  }
                  this.dateArray.push(day)
                  this.label.push(i)
                  starts++
                  t++
                }
                const m_d = {
                  'colspan' : t,
                  'month': monthNow
                }
                this.descDateArray.push(m_d)
                setTimeout( () => {
                  document.getElementById('periode').style.width  = this.$refs.column[0].offsetWidth + 'px'
                  document.getElementById('periodeMonth').style.width  = this.$refs.columnMonth[0].offsetWidth + 'px'
                }, 500)
              }
            }
          )
      },
      async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }

      },
      makedata(item, label) {
        let data = []
        let dataset = []
        let i, k = 0
        for (i in item) {
          const items = {
            index: item[i].index,
            total: item[i].total,
            satuan: item[i].total_satuan
          }
          data.push(items)
        }

        for (let j = 0; j < this.totalday; j++) {
          if (data.length == 0) {
            dataset.push(0)
          } else {
            if (data[k]) {
              if (j === data[k].index) {
                // if (data[k].satuan == 'int') {
                dataset.push(data[k].total)
                // }
                k++
              } else {
                dataset.push(0)
              }
            } else {
              dataset.push(0)
            }

          }

        }
        var labels
        if (label == true) {
          labels = this.labelMonth
        } else {
          labels = this.label
        }
        this.datacollection = {
          labels: labels,
          datasets: [
            {
              label: 'Data',
              backgroundColor: 'transparent',
              borderColor: '#4dbd74',
              data: dataset
            }
          ]
        }
      },
      goToModal(item, i, index) {
          for (let k in item) {
            if (item.hasOwnProperty(k)) {
              if (item[k].index == i) {
                var links = item[k].total_detail
                if (index == 11) {
                  this.hrefCreate = this.changeToURL(links.detail.create)
                  this.hrefSolved = this.changeToURL(links.detail.solved)
                  this.today = links.data.create_today
                  this.prev = links.data.create_prev
                  this.solved = links.data.solved_total
                  this.total = links.data.create_total
                  this.remote = true
              } else if (index == 15) {
                  this.hrefCall = this.getURL(item[k].date)
                  this.call = links.data.call
                  this.answer = links.data.answer
                  this.persentase = true
              } else if (index == 27) {
                  this.solved = links.data.solved
                  this.visit = links.data.visit
                  this.case_total = links.data.case_total
                  this.hrefSolved = this.changeToURL(links.detail.solved)
                  this.hrefVisit = this.changeToURL(links.detail.visit)
                  this.open_problem = true
                }
              }
            }
          }

      },
      getURL(call) {
        var month = 1
        if(call.length > 7) {
          month = 0
        }
        // return '#/kpi/helpdesk/detail?create=' + call +
        return '#/helpdesk/kpi/detail?create=' + call +
          '&pic=' + this.myValues.toString() +
          '&key=7&type=' + month
      },
      changeToURL(api) {
        var newURL = new URL(api)
        var check = (newURL.pathname).split('month/12/')
        var user, month = 0
        if (check[1]) {
          user = check[1]
          month = 1
        } else {
          var n = (newURL.pathname).split('/helpdesk/reportkpi/')
          user = n[1]
        }
        var create = newURL.searchParams.get('detail')
        var key = newURL.searchParams.get('label')
        return '#/kpi/helpdesk/detail?create=' + create +
          '&pic=' +user +
          '&key=' + key +
          '&type=' + month
      },
      linkDetail(item, index, i, name, month, mode) {
        this.$store.commit('change', name)
        let links
        let j = 0
        for (let i in item) {
          if (item.hasOwnProperty(i)) {
            if (item[i].index == index) {
              links = item[i].total_detail
              if (typeof links === 'object') {
                if (links.data.call) {
                  this.call = links.data.call
                  this.answer = links.data.answer
                  this.persentase = true
                } else if (links.data.create_today) {
                  this.today = links.data.create_today
                  this.prev = links.data.create_prev
                  this.solved = links.data.solved_total
                  this.total = links.data.create_total
                  this.remote = true
                }
                return false
              }
              break
            }
          }
        }
        // console.log(links.substr(-10))
        this.getParam(links, i, month, mode)
      },
      submit() {
        this.isSubmit = true
        // console.log(this.bulan)
        // console.log(this.years)
        //
        //
        // return false
        var date, month
        if (this.myValues.length == 0 || !this.branch) {
          window.scrollTo(0,0)
          return false
        }
        if (this.radio == 2) {
          this.$router.replace({
            name: 'kpi',
            query: {
              start: moment(this.start).format('YYYY-MM-DD'),
              end: moment(this.end).format('YYYY-MM-DD'),
              user: this.myValues.toString(),
              mode: '1'
            }
          })
          /*date = {
            start:moment(this.start).format('YYYY-MM-DD'),
            end: moment(this.end).format('YYYY-MM-DD'),
            month: false
          }
          month = false*/
        } else {
          var stPeriodik = this.years + '-' + this.bulan
          this.$router.replace({
            name: 'kpi',
            query: {
              start: moment(stPeriodik, 'YYYY-MMMM').format('YYYY-MM'),
              end: moment(stPeriodik, 'YYYY-MMMM').format('YYYY-MM'),
              user: this.myValues.toString(),
              mode: '0'
            }
          })
          /*const months = {
            start: this.start,
            end: this.end,
            month: false
          }
          if (this.myValues.length > 0) {
            this.getDataKPI(this.myValues.toString(), months, months.month)
          }*/
          /*date = {
            month: true
          }*/
          // month = true
        }
        // if (this.myValues.length > 0) {
        //   this.getDataKPI(this.myValues.toString(), date, month)
        // }
      },
      getParam(date, i, month, mode) {
        const name = this.myValues.toString()
        var urlParam
        if (date.detail) {
          var urlParams = new URL(date.detail.create)
          var urlParams2 = new URL(date.detail.solved)
          urlParam = this.$router.resolve({
            path: 'helpdesk/kpi/detail',
            query: {
              solved: urlParams.searchParams.get('detail'),
              create: urlParams2.searchParams.get('detail'),
              pic: name,
              key: urlParams.searchParams.get('label'),
              type: month
            }
          })

        } else {
          var url = new URL(date)
          urlParam = this.$router.resolve({
            path: 'helpdesk/kpi/detail',
            query: {
              create: url.searchParams.get('detail'),
              pic: name,
              key: url.searchParams.get('label'),
              type: month
            }
          })
        }
        window.open(urlParam.href, '_blank')
      },
      changeGetParam(date, i, month) {

      },
      alluser() {
        var i, data = []
        if ( this.check === false ) {
          for (i = 0; i < this.list.length; i++) {
            data.push(this.list[i].id)
          }
          this.myValues = data
          this.check = true
          this.checkName = 'Uncheck'
        } else {
          this.myValues = data
          this.check = false
          this.checkName = 'All'
        }
      },
      // doSearch() {
      //   this.isLoading = true;
      //   api.ListEvents({
      //     q: this.$route.query.q
      //   }).then((res) => {
      //     this.results = res.events;
      //     this.isLoading = false;
      //   }).catch(() => {
      //     this.isLoading = false;
      //   });
      // },
      goToMonth(index, radio) {
        if (radio == 1 && index == 12) {
          let create, user
          create = this.$route.query.start
          user = this.$route.query.user
          return '#/helpdesk/kpi/detail?create=' + create +
          '&pic=' +user +
          '&key=12&type=1'
        } else {
          return false
        }
      }
    },
    filters: {
      moment: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      },
      total: function (values, index, month) {
        let total = 0, create = 0, solved = 0, n = 0
        var persen = false, second = false
        // if (values.value) {
        for (let i in values.value) {
          if (values.value.hasOwnProperty(i)) {
            const now = moment('2019-04-01' , 'YYYY-MM-DD').format('x');
            const date = moment(values.value[i].date, 'YYYY-MM').format('x');
            if (now <= date) {
              if (values.value[i].total_satuan == 'int') {
                if(index == 12) {
                  for (let k in values.value[i].total_detail_value){
                    total += Number(values.value[i].total_detail_value[k])
                    n++
                  }
                } else {
                  total = total + values.value[i].total
                  n++
                }

              } else if (values.value[i].total_satuan == 'seconds') {
                if(index == 9 || index == 10 || index == 13) {
                  for (let k in values.value[i].total_detail_value){
                    // console.log(values.value[i].total_detail_value[k])
                    total += Number(values.value[i].total_detail_value[k])
                    n++
                  }
                } else {
                  total = total + Number(values.value[i].total)
                  n++
                }
                second = true
              } else {
                if (values.value[i].total_detail.call) {
                  create = create + values.value[i].total_detail.call
                  solved = solved + values.value[i].total_detail.answer
                } else if (values.value[i].total_detail.data.call) {
                  create = create + values.value[i].total_detail.data.call
                  solved = solved + values.value[i].total_detail.data.answer
                } else if (values.value[i].total_detail.data.case_total) {
                  create = create + values.value[i].total_detail.data.case_total
                  solved = solved + Number(values.value[i].total_detail.data.solved)
                } else {
                  create = create + values.value[i].total_detail.data.create_total
                  solved = solved + values.value[i].total_detail.data.solved_total
                }
                persen = true
              }
            }
          }
        }

        if (index == 12 ) {
          if(total){
            total = total / n
          }else {
            total =  0
          }
        }
        if (persen == true) {
          total = parseFloat(solved / create * 100).toFixed(2)
        } else if (second == true) {
          var d;
          if (index == 29) {
            d = total
          } else {
             d = total / n;
          }
          var h = Math.floor(d / 3600);
          var m = Math.floor(d % 3600 / 60);
          var s = Math.floor(d % 3600 % 60);

          var hDisplay = h > 9 ? h + ":" : '0' + h + ':';
          var mDisplay = m > 9 ? m + ":" : '0' + m + ":";
          var sDisplay = s <= 9 ? '0' + s : s;
          total = hDisplay + mDisplay + sDisplay;
        } else {
          if (total % 1 !== 0) {
            total = total.toFixed(2)
          }
        }
        return total
      },
      nextValue: function (item, index, month) {
        for (let i in item) {
          if (item.hasOwnProperty(i)) {
            if (item[i].index == index) {
              if (month) {
                const now = moment('2019-04-01' , 'YYYY-MM-DD').format('x');
                const date = moment(item[i].date, 'YYYY-MM').format('x');
                if (now > date) {
                  return ''
                }
              }
              if (item[i].total_satuan == 'seconds') {
                var d = Number(item[i].total)
                var h = Math.floor(d / 3600)
                var m = Math.floor(d % 3600 / 60)
                var s = Math.floor(d % 3600 % 60)

                var hDisplay = h > 9 ? h + ":" : '0' + h + ':'
                var mDisplay = m > 9 ? m + ":" : '0' + m + ":"
                var sDisplay = s <= 9 ? '0' + s : s
                return hDisplay + mDisplay + sDisplay;
              } else if (item[i].total % 1 !== 0) {
                return item[i].total.toFixed(2)
              }
              return item[i].total
            }
          }
        }
        return ''
      },
      valueGetHref: function (item, index) {
        for (let i in item) {
          if(item[i].index == index) {
            var url = item[i].total_detail
            var newURL = new URL(url)
            var check = (newURL.pathname).split('month/12/')
            var user, month = 0
           if (check[1]) {
              user = check[1]
              month = 1
           } else {
              var n = (newURL.pathname).split('/helpdesk/reportkpi/')
             user = n[1]
           }
            var create = newURL.searchParams.get('detail')
            var key = newURL.searchParams.get('label')
            // return '#/kpi/helpdesk/detail?create=' + create +
            return '#/helpdesk/kpi/detail?create=' + create +
              '&pic=' +user +
              '&key=' + key +
              '&type=' + month
          }
        }
      }

    }
  }
</script>
<style scoped>
  table.table-info > tr {
    height: 40px;
  }

  .mx-calendar-icon {
    height: 0px !important;
  }

  td.minw {
    min-width: 86px;
  }

  td.tag {
    min-width: 400px;
  }

  th{
    min-width: 86px;
  }

#table-Months th {
  min-width: 100px; 
}

#table-Months td.minw {
    min-width: 100px;
}



  .namePointer:hover {
    color: #01195a;
    text-decoration: underline;
  }

  .kpiList{
    width: 60%;
    padding: 20px;
  }

  #myhead>tr>th:first-child,
  #myhead1>tr>th:first-child{
    min-width: 400px;
  }


  @media only screen and (max-width: 980px) {
    .kpiList {
      width: 100%;
    }

    #parent1 {
      margin-block-start: 40px;
    }

    td:first-child,
    th:first-child {
     min-width:105px;
    }

    #myhead>tr>th:first-child,
    #myhead1>tr>th:first-child{
     min-width: 105px;
    }

  }

 /* .horizontal-scroll {
    width: 100%;
    overflow: auto;
    margin-left: 30em;
  }

  .horizontal-scroll > table > * > tr > th:first-child,
  .horizontal-scroll > table > * > tr > td:first-child {
    position: absolute;
    width: 30em;
    margin-left: -30em;
    margin-top: -1.5px;
  }

  .horizontal-scroll > table > * > tr > th,
  .horizontal-scroll > table > * > tr > td {
    white-space: nowrap;
  }*/

  span.textper {
    color: #63c2de;
  }
  table.table > tbody.bodySame>tr> td:nth-child(2n),
  table.table > thead>tr> th:nth-child(2n) {
    background: #e7e8ea;
  }

  .defaultHead{
    height: 45px;
    background: #dddddd;
  }

  #parent, #parent1 {
    position: static;
    /*left: 10vw;*/
    /*top: 15vh;*/
    width: 98vw;
    height: 75vh;
    overflow: hidden;
  }

  table.treand {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    /*border: 1px solid #ccc;*/
    border-collapse: collapse;
    overflow: hidden;
    /* Use this to create a "dead" area color if table is too wide for cells */
  }

  thead {
    /*
    Grow thead automatically to fit content, don't shrink it
    proportionately to the body.
    */
    flex: 1 0 auto;
    display: block;
    /* x-scrolling will be managed via JS */
    overflow-x: hidden;
    /*
    Keep header columns aligned with useless scrollbar.
    For IE11, use "dead area" color to hide scrollbar functions
    */
    overflow-y: scroll;
    scrollbar-base-color: #ccc;
    scrollbar-face-color: #ccc;
    scrollbar-highlight-color: #ccc;
    scrollbar-track-color: #ccc;
    scrollbar-arrow-color: #ccc;
    scrollbar-shadow-color: #ccc;
    scrollbar-dark-shadow-color: #ccc;
  }

  /*
  For Webkit, use "dead area" color to hide scrollbar functions
  TODO: on Chrome/Safari for Mac, scrollbars are not shown anyway and
  this creates an extra block. No impact on iOS Safari.
  */
  thead::-webkit-scrollbar { display: none;  }

  /* Scroll the actual tbody (second child on all browsers) */
  tbody {
    display: block;
    overflow: scroll;
  }

  /* IE11 adds an extra tbody, have to hide it */
  tbody:nth-child(3) { display: none; }

  /* The one caveat, a hard-set width is required. */


  table.table>*>tr>td:first-child,
  th:first-child {

    position: sticky;
    position: -webkit-sticky;
    left:0;
    background: #f2f2f2;
  }
 #parent1 {
   margin-top: 20px !important;
 }
  .btn-second{
    color: #fff;
    background-color: #b0b0b0;
  }

</style>
